<div *ngIf="showMessage" class="alert white-container-box link-expired-alert">
  <i class="fa fa-exclamation-triangle fa-3x text-warning"></i>
  <h5 class="mb-lg">
    This link has expired, please log in to the
    <a href="#">Patient Portal</a>
    or contact your provider for more details.
  </h5>
  <a href="#" class="btn btn-secondary">Okay</a>
</div>
